<template>
  <div>
    <div class="user-info">
      <a-dropdown>
        <a @click="(e) => e.preventDefault()">
          <img src="../assets/images/user_img.png" class="head-img" />
          <span class="user-name">{{ this.$store.state.user.name }}</span>
        </a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a @click="changePwd()">修改密码</a>
          </a-menu-item>
          <a-menu-item>
            <a @click="doLogOut()">退出登录</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div>
      <user-edit-pass
        :u_id="u_id"
        v-if="changePwdShow"
        @onClose="onClose"
      ></user-edit-pass>
    </div>
  </div>
</template>
<script>
import UserEditPass from "./UserEditPass";

import { DoLogout } from "@/api/login";
export default {
  name: "UserInfo",
  components: { UserEditPass },
  data() {
    return {
      name: this.$store.state.user.name,
      u_id: this.$store.state.user.id,
      changePwdShow: false,
    };
  },
  created() {
    setTimeout(() => {
      this.u_id = this.$store.state.user.id;
    }, 100);
  },
  methods: {
    doLogOut() {
      DoLogout()
        .then((response) => {
          if (response.code == "200") {
            localStorage.removeItem("userMsg");
            this.$store.commit("SET_ROLES", "");
            sessionStorage.removeItem("token");
            this.$router.push({ path: "/Login" });
            sessionStorage.removeItem("roles");
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
      // localStorage.removeItem("userMsg");
      // this.$store.commit("SET_CURRENT", "");
    },
    onClose() {
      this.changePwdShow = false;
    },
    changePwd() {
      this.changePwdShow = true;
    },
  },
};
</script>
<style lang="less" scoped>
.user-info {
  position: fixed;
  top: 0;
  right: 40px;
}
.head-img {
  padding-right: 6px;
}
.user-name {
  color: #595959;
  font-size: 14px;
  vertical-align: middle;
}
</style>
